import React from 'react';

const SolutionOverview = () => {
  const networkLocations = [
    { name: "Downtown Coffee Shop", status: "active", earning: "₹1,680/month" },
    { name: "Mall Food Court", status: "active", earning: "₹12,400/month" },
    { name: "Gym Reception", status: "pending", earning: "₹1,420/month" }
  ];

  const steps = [
    {
      number: 1,
      title: "Connect Your Screen",
      description: "Register your display location and specifications. Our team handles technical setup and content management."
    },
    {
      number: 2,
      title: "Smart Matching",
      description: "Our AI matches relevant advertisers to your screen based on location, audience, and optimal revenue potential."
    },
    {
      number: 3,
      title: "Earn Automatically",
      description: "Receive monthly payments automatically. Track performance and earnings through your personalized dashboard."
    }
  ];

  return (
    <section id="how-it-works" className="py-20 section-separator">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            The Complete Solution
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Connect screen owners with advertisers through our intelligent marketplace platform
          </p>
        </div>

        {/* Interactive Network Map */}
        <div className="bg-white rounded-2xl shadow-card p-8 mb-16">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <h3 className="text-2xl font-bold text-text-primary mb-4">Live Network Map</h3>
              <p className="text-text-secondary mb-6">
                Explore available screen locations in real-time. Filter by audience demographics, screen size, and earning potential.
              </p>
              <div className="space-y-4">
                {networkLocations.map((location, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-surface rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className={`w-3 h-3 rounded-full ${
                        location.status === 'active' ? 'bg-success animate-pulse' : 'bg-warning'
                      }`}></div>
                      <span className="font-medium">{location.name}</span>
                    </div>
                    <span className="text-primary font-semibold">{location.earning}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:w-1/2">
              <div className="relative bg-gradient-to-br from-primary/10 to-accent/10 rounded-xl p-8 h-80">
                <img 
                  src="images/indiamap.jpg" 
                  alt="Interactive network map showing screen locations" 
                  className="w-full h-full object-cover rounded-lg opacity-80"
                  onError={(e) => {
                    e.target.src = 'https://images.pexels.com/photos/590016/pexels-photo-590016.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="bg-white/90 backdrop-blur-sm rounded-lg p-6 text-center">
                    <div className="text-2xl font-bold text-primary mb-2">247</div>
                    <div className="text-sm text-text-secondary">Active Screens</div>
                    <div className="text-sm text-text-secondary">Across 5 Cities</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* How It Works Steps */}
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-primary">{step.number}</span>
              </div>
              <h3 className="text-xl font-semibold text-text-primary mb-4">{step.title}</h3>
              <p className="text-text-secondary">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionOverview;